export default __webpack_public_path__ + "static/media/aiEmailEnvelope.bdbe8333.svg";